import { render, staticRenderFns } from "./my-footer.vue?vue&type=template&id=885e437c&"
import script from "./my-footer.vue?vue&type=script&lang=js&"
export * from "./my-footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\i\\au_kyujin_web\\src\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('885e437c')) {
      api.createRecord('885e437c', component.options)
    } else {
      api.reload('885e437c', component.options)
    }
    module.hot.accept("./my-footer.vue?vue&type=template&id=885e437c&", function () {
      api.rerender('885e437c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Frontend/components/my-footer.vue"
export default component.exports